module.exports = {
    headTitle:{
        home:'首页',
        getHome:'仪表盘',
        nodeList:'节点列表',
        recharge:'充值购买',
        recommend:'有奖购买',
        customerService:'客户服务',
    }
}